import { render, staticRenderFns } from "./pondTab.vue?vue&type=template&id=c9bba2a2&"
import script from "./pondTab.vue?vue&type=script&lang=js&"
export * from "./pondTab.vue?vue&type=script&lang=js&"
import style0 from "./pondTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports